import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import ContactDetail from "@/pages/ContactDetail";
import Pipelines from "@/pages/Pipelines";
import CalendarPage from "@/pages/CalendarPage";
import Funnels from "@/pages/Funnels";
import FunnelEditor from "@/pages/FunnelEditor";
import PublicBooking from "@/pages/PublicBooking";
import PublicCalendarBooking from "@/pages/PublicCalendarBooking";
import PublicLanding from "@/pages/PublicLanding";
import Settings from "@/pages/Settings";
import BillingSettings from "@/pages/BillingSettings";
import WorkspacesPage from "@/pages/WorkspacesPage";
import Automations from "@/pages/Automations";
import AutomationEditor from "@/pages/AutomationEditor";
import WorkflowReport from "@/pages/WorkflowReport";
import Outbox from "@/pages/Outbox";
import Inbox from "@/pages/Inbox";
import ExpensesPage from "@/pages/ExpensesPage";
import ExpensesReports from "@/pages/ExpensesReports";
import TimeTrackerPage from "@/pages/TimeTrackerPage";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import SuperAdmin from "@/pages/SuperAdmin";
import DevDashboard from "@/pages/DevDashboard";
import DevProjectDetail from "@/pages/DevProjectDetail";
import CopilotRecommendationsPage from "@/pages/CopilotRecommendationsPage";
import PropGenDashboard from "@/pages/propgen/PropGenDashboard";
import PropGenWorkspace from "@/pages/propgen/PropGenWorkspace";
import PropGenEstimate from "@/pages/propgen/PropGenEstimate";
import PropGenAdminUsers from "@/pages/propgen/PropGenAdminUsers";
import { ThemeProvider } from "@/context/ThemeContext";
import { TimerProvider } from "@/context/TimerContext";

const Guarded = ({ children }) => (
  <ProtectedRoute>
    <AppLayout>{children}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
            <TimerProvider>
          <Toaster position="bottom-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/signup" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />

            {/* Public pages */}
            <Route path="/book/:email" element={<PublicBooking />} />
            <Route path="/book/c/:slug" element={<PublicCalendarBooking />} />
            <Route path="/book/c/:slug/cancel/:token" element={<PublicCalendarBooking cancelMode />} />
            <Route path="/p/:slug" element={<PublicLanding />} />

            {/* App */}
            <Route path="/dashboard" element={<Guarded><Dashboard /></Guarded>} />
            <Route path="/contacts" element={<Guarded><Contacts /></Guarded>} />
            <Route path="/contacts/:id" element={<Guarded><ContactDetail /></Guarded>} />
            <Route path="/pipelines" element={<Guarded><Pipelines /></Guarded>} />
            <Route path="/calendar" element={<Guarded><CalendarPage /></Guarded>} />
            <Route path="/funnels" element={<Guarded><Funnels /></Guarded>} />
            <Route path="/funnels/:id" element={<Guarded><FunnelEditor /></Guarded>} />
            <Route path="/automations" element={<Guarded><Automations /></Guarded>} />
            <Route path="/automations/:id" element={<Guarded><AutomationEditor /></Guarded>} />
            <Route path="/automations/:id/report" element={<Guarded><WorkflowReport /></Guarded>} />
            <Route path="/outbox" element={<Guarded><Outbox /></Guarded>} />
            <Route path="/inbox" element={<Guarded><Inbox /></Guarded>} />
            <Route path="/expenses" element={<Guarded><ExpensesPage /></Guarded>} />
            <Route path="/expenses/reports" element={<Guarded><ExpensesReports /></Guarded>} />
            <Route path="/time" element={<Guarded><TimeTrackerPage /></Guarded>} />
            <Route path="/settings" element={<Guarded><Settings /></Guarded>} />
            <Route path="/settings/billing" element={<Guarded><BillingSettings /></Guarded>} />
            <Route path="/workspaces" element={<Guarded><WorkspacesPage /></Guarded>} />
            <Route path="/superadmin" element={<Guarded><SuperAdmin /></Guarded>} />
            <Route path="/superadmin/development" element={<Guarded><DevDashboard /></Guarded>} />
            <Route path="/superadmin/development/:id" element={<Guarded><DevProjectDetail /></Guarded>} />
            <Route path="/copilot/recommendations" element={<Guarded><CopilotRecommendationsPage /></Guarded>} />
            <Route path="/superadmin/propgen" element={<Guarded><PropGenDashboard /></Guarded>} />
            <Route path="/superadmin/propgen/projects/:id" element={<Guarded><PropGenWorkspace /></Guarded>} />
            <Route path="/superadmin/propgen/projects/:id/emergent-estimate" element={<Guarded><PropGenEstimate /></Guarded>} />
            <Route path="/superadmin/propgen/admin/users" element={<Guarded><PropGenAdminUsers /></Guarded>} />
          </Routes>
            </TimerProvider>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
